export default class Menu {
    constructor() {
        let self = this;
        self.html = document.querySelector('html');
        self.toggleButton = document.querySelector('#menu-toggle');
        self.menuModal = document.querySelector('#menu-mobile');
        self.header = document.querySelector('body > header');
        self.body = document.querySelector('body');
        self.mobileLogoLink = document.querySelector('.mobile-header .logo-link');
        // Initialize aria-hidden attribute
        this.menuModal.setAttribute('aria-hidden', 'true');
        this.menuEventListeners();
        this.hashLinkListeners();
        window.addEventListener('load', function () {
            self.scrollToHashLink();
        });
    }
    scrollToHashLink() {
        const hash = window.location.hash;
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
    hashLinkListeners() {
        const self = this;
        const links = document.querySelectorAll('a');
        // links with hash in it
        const hashLinks = Array.from(links).filter(function (link) {
            const href = link.getAttribute('href');
            return href && href.search('#') !== -1;
        });
        if (hashLinks.length === 0) {
            return;
        }
        hashLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                const targetId = this.getAttribute('href').split('#')[1];
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    e.preventDefault();
                    self.menuModal.classList.remove('mobile-open');
                    self.menuModal.setAttribute('aria-hidden', 'true');
                    self.html.classList.remove('no-scroll');
                    self.body.classList.remove('no-scroll');
                    self.header.classList.remove('mobile-open');
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                    window.history.pushState(null, '', '#' + targetId);
                }
            });
        });
    }
    getFocusableElements() {
        // define focus trap boundary
        const focusTrapBoundary = document.querySelector('.mobile-header');
        // get all focusable elements within focus trap
        const allFocusableElements = focusTrapBoundary.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        // get focusable elements from mobile menu
        const menuFocusableElements = this.menuModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        // combine all focusable elements into array
        this.focusableElements = Array.from(allFocusableElements);
        // add menu elements arent already in array
        Array.from(menuFocusableElements).forEach(element => {
            if (!this.focusableElements.includes(element)) {
                this.focusableElements.push(element);
            }
        });
        // filter out any hidden or disabled elements
        this.focusableElements = this.focusableElements.filter(element => {
            return element.offsetParent !== null &&
                !element.hasAttribute('disabled') &&
                element.getAttribute('tabindex') !== '-1';
        });
        if (this.focusableElements.length > 0) {
            this.firstFocusableElement = this.focusableElements[0];
            this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
        }
    }
    handleFocusTrap(event) {
        if (!this.menuModal.classList.contains('mobile-open')) {
            return;
        }
        // if tab or shift+tab was pressed
        if (event.key !== 'Tab') {
            return;
        }
        // if no focusable elements - focus menu itself
        if (this.focusableElements.length === 0) {
            event.preventDefault();
            this.menuModal.focus();
            return;
        }
        const activeElement = document.activeElement;
        // if shift+tab on first element - focus last element
        if (event.shiftKey) {
            if (activeElement === this.firstFocusableElement) {
                event.preventDefault();
                this.lastFocusableElement.focus();
            }
        }
        // if tab on last element - focus first element
        else {
            if (activeElement === this.lastFocusableElement) {
                event.preventDefault();
                this.firstFocusableElement.focus();
            }
        }
    }
    closeMenuOnEscape(event) {
        if (event.key === 'Escape' && this.menuModal.classList.contains('mobile-open')) {
            this.closeMobileMenu();
        }
    }
    setInitialFocus() {
        // wait for menu to be fully visible
        setTimeout(() => {
            // focus on first focusable element
            if (this.firstFocusableElement) {
                this.firstFocusableElement.focus();
            }
            // if no focusable elements, focus menu container
            else {
                this.menuModal.focus();
            }
        }, 100);
    }
    closeMobileMenu() {
        this.toggleButton.classList.remove('active');
        this.menuModal.classList.remove('mobile-open');
        this.menuModal.setAttribute('aria-hidden', 'true');
        this.html.classList.remove('no-scroll');
        this.body.classList.remove('no-scroll');
        this.header.classList.remove('mobile-open');
        // return focus to toggle button
        this.toggleButton.focus();
    }
    openMobileMenu() {
        this.toggleButton.classList.add('active');
        this.menuModal.classList.add('mobile-open');
        this.menuModal.setAttribute('aria-hidden', 'false');
        this.html.classList.add('no-scroll');
        this.body.classList.add('no-scroll');
        this.header.classList.add('mobile-open');
        // update focusable elements and set initial focus
        this.getFocusableElements();
        this.setInitialFocus();
    }
    menuEventListeners() {
        let self = this;
        this.toggleButton.addEventListener('click', function (e) {
            e.preventDefault();
            if (self.menuModal.classList.contains('mobile-open')) {
                self.closeMobileMenu();
            }
            else {
                self.openMobileMenu();
            }
        });
        // close menu when logo is clicked
        if (this.mobileLogoLink) {
            this.mobileLogoLink.addEventListener('click', () => {
                if (this.menuModal.classList.contains('mobile-open')) {
                    this.closeMobileMenu();
                }
            });
        }
        // event listener for escape key
        document.addEventListener('keydown', (e) => this.closeMenuOnEscape(e));
        // event listener for focus trap
        document.addEventListener('keydown', (e) => this.handleFocusTrap(e));
        // close menu when clicking outside
        this.menuModal.addEventListener('click', (e) => {
            // if click is on menu modal background
            if (e.target === this.menuModal) {
                this.closeMobileMenu();
            }
        });
        // close menu when clicking on navigation links in mobile menu
        const mobileMenuLinks = this.menuModal.querySelectorAll('a');
        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', () => {
                this.closeMobileMenu();
            });
        });
        // close menu when clicking on language switcher links
        const languageLinks = this.menuModal.querySelectorAll('.wpml-ls-link');
        languageLinks.forEach(link => {
            link.addEventListener('click', () => {
                this.closeMobileMenu();
            });
        });
        // cclose menu when clicking on contact links in mobile menu
        const contactLinks = this.menuModal.querySelectorAll('.navigation-contacts a');
        contactLinks.forEach(link => {
            link.addEventListener('click', () => {
                this.closeMobileMenu();
            });
        });
    }
}
